import { createFileRoute, Outlet } from "@tanstack/react-router";

import { SiteFrame } from "@/session/site-frame";

export const Route = createFileRoute("/_site")({ component: SiteLayout });

function SiteLayout() {
  return (
    <SiteFrame>
      <Outlet />
    </SiteFrame>
  );
}
